import { generalApiPost } from './apiPost'

const logoutApi = generalApiPost('logout')

export const updatePassword = generalApiPost('update-password')

export default logoutApi
